import { directionAPI, directionOrdersApi, promoCodeAPI, usersAPI } from '@/api'
import { jsonConvert } from '@/helpers/jsonConvert'

export const fetchCourseAndTariffs = async (
  id: number,
): Promise<ICourse | null> => {
  try {
    const res = await directionAPI.get({
      id,
      expand: [
        'directionTariffs.directionTariffNotices',
        'directionTariffs.tariffPeriods',
        'seniorSeminarians',
      ],
    })

    return {
      ...res.data,
      description: jsonConvert(res.data.description, 'json'),
      directionTariffs:
        res.data.directionTariffs?.map((item: ICourseTariff) => ({
          ...item,
          description: jsonConvert(item.description, 'json'),
        })) ?? [],
    }
  } catch (error) {
    console.error('Ошибка загрузки настроек курса:', error)
    return null
  }
}

export const checkPromoCode = async (
  name: string,
): Promise<IPromoCodeDiscount | null> => {
  try {
    // return {
    //   id: 5,
    //   editor_id: 6,
    //   name: 'НГ2023',
    //   type: 'percent',
    //   discount: 44,
    //   expired_date: '2023-01-20 00:00:00',
    //   created_at: 1670755181,
    //   updated_at: 1670755181,
    // }

    const res = await promoCodeAPI.check(name?.trim())

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка проверки промокода:', error)
    return null
  }
}

export interface ICheckEmailResponse {
  user: IUser | null
  hasCourse: boolean
}

export const checkEmailExist = async (
  email: string,
  courseId: number,
): Promise<ICheckEmailResponse> => {
  try {
    const res = await usersAPI.checkEmail(email?.trim(), courseId)

    return {
      user: res?.data?.data?.user ?? null,
      hasCourse: res?.data?.data?.hasCourse ?? false,
    }
  } catch (error) {
    console.error('Ошибка проверки почты:', error)
    return {
      user: null,
      hasCourse: false,
    }
  }
}

export interface IUserEnrollment {
  name: string
  password: string
  phone: string
  email: string
}

export const courseEnrollment = async (
  courseId: number,
  tariffId: number,
  promoId?: number,
  value?: number,
  user?: IUserEnrollment,
): Promise<PaymentOrder | null> => {
  try {
    const data = new FormData()
    data.append('course_id', courseId?.toString())
    data.append('tariff_id', tariffId?.toString())
    if (promoId) data.append('promo_id', promoId?.toString())
    if (value) data.append('value', value?.toString())
    if (user) data.append('user', JSON.stringify(user))

    const res = await directionOrdersApi.enroll(data)

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка записи на курс:', error)
    return null
  }
}
